import React from 'react';
import { DayStatStrip as KitDayStatStrip } from '@parsina/framework';
import { C } from '@parsina/framework/clinical/src/constants/theme';
import { CT } from '@parsina/framework/tokens';
import { useTranslation } from '@parsina/framework/clinical/src/i18n/index';
import { useReceptionStrings } from '../../lib/receptionStrings';

// ─────────────────────────────────────────────────────────────────────────────
// The day's figures as ONE row (DOCTOR_MOBILE_RECEPTION_REDESIGN §4.3) — the
// mobile KPI zone on a list-dominant cockpit, where the appointments are the
// screen's purpose and the counts only frame them.
//
//   «۱۲ نوبت · ۳ منتظر · ۵ انجام · ۱ لغو»
//
// The row is the kit's `DayStatStrip`, shared with the clinic's phone پذیرش
// (PM-0052); this file only says WHICH figures the doctor reads. The day's
// income is not here: it lives in حسابداری, a bottom tab of its own.
// ─────────────────────────────────────────────────────────────────────────────

const DayStatStrip = ({ counts, loading, isToday }) => {
  const { t, formatNumber } = useTranslation();
  const rs = useReceptionStrings();

  const n = (v) => (loading || v == null ? '–' : formatNumber(v));
  const items = [
    { key: 'total',     value: counts.total,     label: isToday ? rs('dashboard.stats.total') : t('dashboard.counts.total'), color: C.textPrimary },
    { key: 'waiting',   value: counts.waiting,   label: rs('dashboard.stats.waiting'),   color: CT.warnInk },
    { key: 'completed', value: counts.completed, label: rs('dashboard.stats.completed'), color: C.green },
    { key: 'cancelled', value: counts.cancelled, label: rs('dashboard.stats.cancelled'), color: C.red },
  ];

  return (
    <KitDayStatStrip
      items={items}
      loading={loading}
      format={formatNumber}
      ariaLabel={rs('dashboard.stats.aria', {
        total: n(counts.total), waiting: n(counts.waiting), completed: n(counts.completed), cancelled: n(counts.cancelled),
      })}
    />
  );
};

export default DayStatStrip;
